// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__Tl0ad","bigColWidth":"Table_bigColWidth__171KQ","biggerColWidth":"Table_biggerColWidth__2L4LK","row":"Table_row__2Xqop","col":"Table_col__3UE6L"};